import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import RootLayout from './components/RootLayout';
import OurFleet from './pages/OurFleet';
import Blog from './pages/Blog';
import OurServices from './pages/OurServices';
import ContactUs from './pages/ContactUs';
import BookNow from './pages/BookNow';
import AboutUs from './pages/AboutUs';
import CitiesWeServe from './pages/CitiesWeServe';
import AirportTransfer from './pages/AirportTransfer';
import HourlyService from './pages/HourlyService';
import CorporateService from './pages/CorporateService';
import WeddingTransportation from './pages/WeddingTransportation';
import PartyBuses from './pages/PartyBuses';
import CruiseTransfers from './pages/CruiseTransfers';
import JerseyCity from './pages/JerseyCity';
import Hoboken from './pages/Hoboken';
import Weehawken from './pages/Weehawken';
import UnionCity from './pages/UnionCity';
import WestNewYork from './pages/WestNewYork';
import Guttenberg from './pages/Guttenberg';
import Secaucus from './pages/Secaucus';
import NorthBergen from './pages/NorthBergen';
import Bayonne from './pages/Bayonne';
import Fairview from './pages/Fairview';
import CliffsidePark from './pages/CliffsidePark';
import Edgewater from './pages/Edgewater';
import Harrison from './pages/Harrison';
import Kearny from './pages/Kearny';
import Ridgefield from './pages/Ridgefield';
import ConcertsEvents from './pages/ConcertsEvents';
import VehicleDetail from './pages/VehicleDetail';
import NewYorkCity from './pages/NewYorkCity';
import Connecticut from './pages/Connecticut';
import NewJersey from './pages/NewJersey';
import Pennsylvania from './pages/Pennsylvania';
import WashingtonDC from './pages/WashingtonDC';
import RhodeIsland from './pages/RhodeIsland';
import FIFAWorldCup2026 from './pages/FIFAWorldCup2026';

const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    children: [
      {
        path: "/",
        element: <App/>
      },
      {
        path: "/about",
        element: <AboutUs/>
      },
      {
        path: "/blog",
        element: <Blog/>
      },
      {
        path: "/booknow", // Changed from /book-now to match your route
        element: <BookNow/>
      },
      {
        path: "/contact",
        element: <ContactUs/>
      },
      {
        path: "/fleet",
        element: <OurFleet/>
      },
      {
        path: "/services", // Fixed: Changed from /fleet (duplicate)
        element: <OurServices/>
      },
      {
        path: "/cities", // Fixed: Changed from /fleet (duplicate)
        element: <CitiesWeServe/>
      },
      // Cities - New Service Areas
      {
        path: "/new-york-city",
        element: <NewYorkCity/>
      },
      {
        path: "/connecticut",
        element: <Connecticut/>
      },
      {
        path: "/new-jersey",
        element: <NewJersey/>
      },
      {
        path: "/pennsylvania",
        element: <Pennsylvania/>
      },
      {
        path: "/washington-dc",
        element: <WashingtonDC/>
      },
      {
        path: "/rhode-island",
        element: <RhodeIsland/>
      },
      //Services
      {
        path: "/airport-transfer-service",
        element: <AirportTransfer/>
      },
      {
        path: "/hourly-limo-service",
        element: <HourlyService/>
      },
      {
        path: "/corporate-limo-service",
        element: <CorporateService/>
      },
      {
        path: "/wedding-limousine-service",
        element: <WeddingTransportation/>
      },
      {
        path: "/party-buses", // Keeping this as is since you didn't specify a new route
        element: <PartyBuses/>
      },
      {
        path: "/cruise-transfer-limo-service",
        element: <CruiseTransfers/>
      },
      {
        path: "/concerts-events-limo-service",
        element: <ConcertsEvents/>
      },
      {
        path: "/fifa-world-cup-2026-transportation",
        element: <FIFAWorldCup2026/>
      },
      {
        path: "/fleet/:slug",
        element: <VehicleDetail/>
      },
      // Additional City Routes
      {
        path: "/jersey-city",
        element: <JerseyCity/>
      },
      {
        path: "/hoboken",
        element: <Hoboken/>
      },
      {
        path: "/weehawken",
        element: <Weehawken/>
      },
      {
        path: "/union-city",
        element: <UnionCity/>
      },
      {
        path: "/west-new-york",
        element: <WestNewYork/>
      },
      {
        path: "/guttenberg",
        element: <Guttenberg/>
      },
      {
        path: "/secaucus",
        element: <Secaucus/>
      },
      {
        path: "/north-bergen",
        element: <NorthBergen/>
      },
      {
        path: "/bayonne",
        element: <Bayonne/>
      },
      {
        path: "/fairview",
        element: <Fairview/>
      },
      {
        path: "/cliffside-park",
        element: <CliffsidePark/>
      },
      {
        path: "/edgewater",
        element: <Edgewater/>
      },
      {
        path: "/harrison",
        element: <Harrison/>
      },
      {
        path: "/kearny",
        element: <Kearny/>
      },
      {
        path: "/ridgefield",
        element: <Ridgefield/>
      }
    ]
  }
]);

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

reportWebVitals();
